import React, { Fragment, useState } from "react";
import moment from "moment";

import RenderRoute from "./RenderRoute";
import { convertTimeToReadable } from "../../helpers";
import { getCarrierLogo } from "../../../../utils/flightInfo";
import { formatNumber } from "../../../../utils/convertToNumber";

const ExchangeFlightList = ({
  offer,
  journeys,
  dataMap,
  onSelect,
  flightInfo,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const renderDetail = (offer) => {
    if (!isOpen) return null;

    const getSegment = (segmentRef) => {
      return dataMap?.paxSegments[segmentRef];
    };

    const fares =
      offer?.addOfferItems[0]?.reshopPriceAndFareDetails?.differential?.diff
        ?.fareDetails?.[0];

    return (
      <div className="p-4 my-3 rounded-2xl border border-neutral-200 md:mr-12 md:p-8">
        {fares?.fareComponents?.map((fare, index) => {
          const segment = getSegment(fare?.paxSegmentRefId[0]);

          return (
            <div className="flex flex-col md:flex-row" key={index}>
              <div className="flex flex-shrink-0 justify-center items-center w-32 md:w-20 md:pt-7 lg:w-36">
                <img
                  src={getCarrierLogo(segment?.marketingInfo?.carrierCode)}
                  className="w-20"
                  alt=""
                />
              </div>
              <div className="flex my-2 md:my-0 lg:w-72">
                <div className="flex flex-col flex-shrink-0 items-center py-2">
                  <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
                  <span className="block flex-grow my-1 border-l border-dashed border-neutral-400"></span>
                  <span className="block w-6 h-6 rounded-full border border-neutral-400"></span>
                </div>
                <div className="ml-4 space-y-24 text-sm">
                  <div className="flex flex-col space-y-1">
                    <span className="text-xs font-light text-neutral-500">
                      {moment(segment?.dep?.schedDateTime).format(
                        "ddd, MMM D : hh:mm A"
                      )}
                    </span>
                    <span className="font-medium text-black">
                      {segment?.dep?.stationCode}
                    </span>
                  </div>
                  <div className="flex flex-col space-y-1">
                    <span className="text-xs font-light text-neutral-500">
                      {moment(segment?.arrival?.schedDateTime).format(
                        "ddd, MMM D : hh:mm A"
                      )}
                    </span>
                    <span className="font-medium text-black">
                      {segment?.arrival?.stationCode}
                    </span>
                  </div>
                </div>
              </div>
              <div className="border-l border-neutral-200 md:mx-6 lg:ml-24"></div>
              <div className="flex flex-row justify-between p-2 my-2 md:my-2">
                <ul className="space-y-1 text-sm font-extralight text-black md:space-y-2">
                  <li>Fare: {fare.fbc}</li>
                  <li>Fare Type: {fare?.fareType}</li>
                  <li>
                    Flight time:{" "}
                    <span>{convertTimeToReadable(segment?.duration)}</span>
                  </li>
                  <li>Flight Class: {fare?.cabinName}</li>
                  <li>Flight Number: {segment?.marketingInfo?.flightNumber}</li>

                  <li>Booking Class: {fare?.cabinCode}</li>
                  <li>Operated By: {segment?.operatingInfo?.carrierCode}</li>
                </ul>
              </div>
            </div>
          );
        })}
        <div className="mx-auto"></div>
        <div className="flex flex-col mt-auto space-y-6">
          <button
            className="px-6 py-2 text-white bg-amber-500 rounded-lg"
            onClick={() => {
              onSelect(offer);
            }}
          >
            Select
          </button>
        </div>
      </div>
    );
  };

  function getFareDifference() {
    const total = offer?.addOfferItems?.map((item) => {
      console.log(
        item?.reshopPriceAndFareDetails?.new?.price?.totalAmount?.units
      );
      return item?.reshopPriceAndFareDetails?.differential
        ? item?.reshopPriceAndFareDetails?.differential?.diff?.price
            ?.totalAmount?.units || 0
        : item?.reshopPriceAndFareDetails?.new?.price?.totalAmount?.units -
            flightInfo?.price || 0;
    });

    return Array.isArray(total) ? total.reduce((a, b) => +a + +b, 0) : total;
  }

  function getFareDifference2() {
    const total = offer?.addOfferItems?.map((item) => {
      return item?.reshopPriceAndFareDetails?.differential
        ? item?.reshopPriceAndFareDetails?.differential?.diff?.price
            ?.totalAmount?.units || 0
        : item?.reshopPriceAndFareDetails?.new?.price?.totalAmount?.units;
    });

    return Array.isArray(total) ? total.reduce((a, b) => +a + +b, 0) : total;
  }

  return (
    <div
      className={`overflow-hidden relative space-y-2 w-full bg-white rounded-2xl border shadow transition-shadow nc-FlightCardgroup border-neutral-100 hover:shadow-lg`}
      data-nc-id="FlightCard"
      onClick={() => {
        setIsOpen(!isOpen);
      }}
    >
      <div className="px-4 py-2 leading-8 border-b border-slate-200">
        <div className="flex justify-between">
          <div className="flex flex-shrink-0 items-center">
            <img
              src={getCarrierLogo(offer?.ownerCode)}
              className="object-contain w-12 h-8"
              alt=""
            />
            <h1>{offer?.ownerCode}</h1>
          </div>
          <div className="">
            <h1 className="px-2 mx-3 text-xl font-semibold text-main">
              {/* {offer?.totalPrice?.totalAmount?.units}{" "} */}
              {formatNumber(getFareDifference2())}{" "}
              {offer?.totalPrice?.totalAmount?.currencyCode}
            </h1>
          </div>
        </div>
      </div>
      <div className={`relative px-4 pb-1 sm:pr-20`} data-nc-id="FlightCard">
        <div>
          {journeys?.map((journey, index) => (
            <Fragment key={index}>
              <RenderRoute journey={journey} dataMap={dataMap} />
              <hr />
            </Fragment>
          ))}
          {renderDetail(offer)}
        </div>
      </div>
    </div>
  );
};

export default ExchangeFlightList;
